const IconPhone = ({ className }) => {
    return (
        <svg
            width='25'
            height='25'
            viewBox='0 0 25 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.1039 5.87158C4.83796 5.87158 4.58291 5.97723 4.39486 6.16528C4.21288 6.34726 4.10807 6.59199 4.1015 6.84861C4.33212 10.5025 5.88763 13.9473 8.47703 16.5367C11.0664 19.1261 14.5112 20.6816 18.1651 20.9122C18.4218 20.9057 18.6665 20.8009 18.8485 20.6189C19.0365 20.4308 19.1422 20.1758 19.1422 19.9098V16.5778L15.5517 15.1416L14.487 16.9162C14.2185 17.3637 13.6516 17.5304 13.1836 17.2996C10.8082 16.1281 8.88566 14.2055 7.71415 11.8301C7.48333 11.3621 7.65007 10.7953 8.09756 10.5268L9.87213 9.46204L8.43595 5.87158H5.1039ZM2.97678 4.7472C3.54093 4.18305 4.30608 3.86612 5.1039 3.86612H9.11483C9.52485 3.86612 9.89356 4.11575 10.0458 4.49645L12.0513 9.51011C12.2341 9.96707 12.0582 10.4891 11.6362 10.7423L9.95762 11.7495C10.7837 13.0968 11.9169 14.23 13.2642 15.0561L14.2714 13.3775C14.5246 12.9555 15.0467 12.7796 15.5036 12.9624L20.5173 14.9679C20.898 15.1202 21.1476 15.4889 21.1476 15.8989V19.9098C21.1476 20.7077 20.8307 21.4728 20.2665 22.037C19.7024 22.6011 18.9372 22.918 18.1394 22.918C18.1191 22.918 18.0988 22.9174 18.0786 22.9162C13.9227 22.6636 10.003 20.8988 7.05895 17.9548C4.11489 15.0107 2.3501 11.091 2.09755 6.93514C2.09632 6.91489 2.0957 6.8946 2.0957 6.87432C2.0957 6.07649 2.41264 5.31135 2.97678 4.7472Z'
            />
        </svg>
    );
};

export default IconPhone;
